import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import ReactTooltip from 'react-tooltip'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import config from '../../config'
import {
  Grade,
  AutocompleteSearch,
  Link,
} from '../../components'
import Styles from './IyvScorecard.css'

@CSSModules(Styles,{allowMultiple:true})
class ReportCardRow extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  }

  constructor(props){
    super(props)
    this.state = {
      data: props.data,
    }
  }
  render(){
    const { data } = this.state

    return (
      <div styleName='reportcard-result' >
        <div styleName='reportcard-title-wrap'>
          <div>
            <p styleName='reportcard-result-title'>
              {data.title}
            </p>
            <p styleName='reportcard-result-subtitle'>
              {data.subtitle}
            </p>
          </div>
        </div>
        <div styleName='reportcard-result-grade'>
          <Grade
            grade={data.rgrade}
            square
          />
        </div>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
export default class IyvScorecard extends Component {
  static propTypes = {
    // from fund profile page container
    shareClass: PropTypes.object.isRequired,
    fund: PropTypes.object.isRequired,
  }

  constructor(props){
    super(props)
  }

  render(){
    // images
    const iyvLogoSrc = require( '../../../static/images/iyv-logo-project-of-2021.jpg' )
    const sriIcon = require( '../../../static/images/sri.png' )
    const ussifLogo = require( '../../../static/images/ussif-icon.png' )

    // objects and values
    const { fund, shareClass } = this.props
    const { fund_id, investment_vehicle_id } = shareClass
    const ticker = shareClass.ticker ? shareClass.ticker : 'N'
    const hasSRIBadge = convert.boolean(fund.socially_responsible_fund)
    const hasUssifBadge = convert.float(shareClass.ussif) === 1.5
    const name = format.sanitize(fund.fund_legal_name)
    const urlMid = name+'/'+ticker
    const urlEnd = fund_id+'/'+investment_vehicle_id

    // build a table dataset
    // label, title, figure, url
    let enviroFinData = [
      {
        title: 'Fossil fuels',
        siteTitle: 'Fossil Free Funds',
        subtitle: 'Coal/oil/gas energy, fossil-fired utilities, related financial companies',
        label: 'fossil',
        icon: 'bolt',
        rgrade: fund.grade_fossil,
        link: {
          url: 'https://fossilfreefunds.org/fund/' + urlMid + '/fossil-fuel-investments/' + urlEnd,
          title: fund.fund_legal_name + ' | Fossil Free Funds | Fossil fuel investments'
        }
      },
      // {
      //   title: 'Fossil finance',
      //   siteTitle: 'Fossil Free Funds',
      //   subtitle: 'Investments in banks lending to fossil fuels',
      //   label: 'fossil-bank',
      //   icon: 'bolt',
      //   rgrade: fund.grade_fossil_bank,
      //   link: {
      //     url: 'https://fossilfreefunds.org/fund/' + urlMid + '/fossil-finance-insurance/' + urlEnd,
      //     title: fund.fund_legal_name + ' | Fossil Free Funds | Fossil finance investments'
      //   }
      // },
      // {
      //   title: 'Fossil insurance',
      //   siteTitle: 'Fossil Free Funds',
      //   subtitle: 'Investments in insurance companies insuring fossil fuels',
      //   label: 'fossil-insure',
      //   icon: 'bolt',
      //   rgrade: fund.grade_fossil_insure,
      //   link: {
      //     url: 'https://fossilfreefunds.org/fund/' + urlMid + '/fossil-finance-insurance/' + urlEnd,
      //     title: fund.fund_legal_name + ' | Fossil Free Funds | Fossil insurance investments'
      //   }
      // },
      {
        title: 'Deforestation',
        siteTitle: 'Deforestation Free Funds',
        subtitle: 'Deforestation-risk agriculture, related financial companies, consumer brands',
        label: 'deforestation',
        icon: 'tree',
        rgrade: fund.grade_deforestation,
        link: {
          url: 'https://deforestationfreefunds.org/fund/' + urlMid + '/profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Deforestation Free Funds'
        }
      }
    ]
    let socialFinData = [
      {
        title: 'Gender equality',
        siteTitle: 'Gender Equality Funds',
        subtitle: 'Gender equality scorecard group ranking',
        label: 'gender-equality',
        icon: 'balance-scale',
        rgrade: fund.grade_gender_equality,
        link: {
          url: 'https://genderequalityfunds.org/fund/' + urlMid + '/gender-lens-score/' + urlEnd,
          title: fund.fund_legal_name + ' | Gender Equality Funds'
        }
      },


      {
        title: 'Diversity disclosures',
        siteTitle: 'Social Justice Funds',
        subtitle: 'Diversity disclosures scorecard group ranking',
        label: 'gender-equality',
        icon: 'balance-scale',
        rgrade: fund.grade_dei,
        link: {
          url: 'https://socialjusticefunds.org/fund/' + urlMid + '/profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Social Justice Funds'
        }
      },
      {
        title: 'Racial justice',
        siteTitle: 'Social Justice Funds',
        subtitle: 'Racial justice scorecard group ranking',
        label: 'gender-equality',
        icon: 'balance-scale',
        rgrade: fund.grade_rji,
        link: {
          url: 'https://socialjusticefunds.org/fund/' + urlMid + '/profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Social Justice Funds'
        }
      },
      {
        title: 'LGBTQ+ equity',
        siteTitle: 'Social Justice Funds',
        subtitle: 'LGBTQ+ equity scorecard group ranking',
        label: 'gender-equality',
        icon: 'balance-scale',
        rgrade: fund.grade_hrc,
        link: {
          url: 'https://socialjusticefunds.org/fund/' + urlMid + '/profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Social Justice Funds'
        }
      },
      {
        title: 'Civilian firearms',
        siteTitle: 'Gun Free Funds',
        subtitle: 'Civilian firearms manufacturers, related gun retailers',
        label: 'firearms',
        icon: 'fighter-jet',
        rgrade: fund.grade_guns,
        link: {
          url: 'https://gunfreefunds.org/fund/' + urlMid + '/gun-investments/' + urlEnd,
          title: fund.fund_legal_name + ' | Gun Free Funds'
        }
      },
      {
        title: 'Prison industrial complex',
        siteTitle: 'Prison Free Funds',
        subtitle: 'Prisons and borders industry, including private prison operators',
        label: 'prisons',
        icon: 'fighter-jet',
        rgrade: fund.grade_prison_industrial_complex,
        link: {
          url: 'https://prisonfreefunds.org/fund/' + urlMid + '/prison-industrial-complex-investments/' + urlEnd,
          title: fund.fund_legal_name + ' | Prison Free Funds'
        }
      },
      {
        title: 'Military weapons',
        siteTitle: 'Weapon Free Funds',
        subtitle: 'Military arms manufacturers, including nuclear weapons, controversial weapons',
        label: 'weapons',
        icon: 'fighter-jet',
        rgrade: fund.grade_military,
        link: {
          url: 'https://weaponfreefunds.org/fund/' + urlMid + '/weapon-investments/' + urlEnd + '?screen=mil',
          title: fund.fund_legal_name + ' | Weapon Free Funds'
        }
      },
      {
        title: 'Tobacco',
        siteTitle: 'Tobacco Free Funds',
        subtitle: 'Tobacco companies, and tobacco-promoting entertainment companies',
        label: 'tobacco',
        icon: 'ban',
        rgrade: fund.grade_tobacco,
        link: {
          url: 'https://tobaccofreefunds.org/fund/' + urlMid + '/tobacco-profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Tobacco Free Funds'
        }
      },
    ]

    // apply some conversion functions to the data
    const finDataConversions = (finData) => {
      for (let i=0; i < finData.length; i++){
        finData[i].grade = format.score(finData[i].rgrade)
        finData[i].sfgrade = finData[i].grade === 'N/A' ? 'NA' : finData[i].grade
      }
      return finData
    }
    enviroFinData = finDataConversions(enviroFinData)
    socialFinData = finDataConversions(socialFinData)

    //
    return (
      <div styleName='reportcard-wrap'>
        <div styleName='reportcard-inner'>
          <div styleName='reportcard-content-gutter'>
            <Link
              to={config.links.aysinvest}
              title='Invest Your Values | As You Sow'
            >
              <img
                src={iyvLogoSrc}
                alt='Invest Your Values'
                styleName='iyv-icon'
              />
            </Link>
            <div styleName='reportcard-title'>
              Sustainability report card
            </div>
            <div styleName='reportcard-info'>
              As You Sow’s <Link
                to={config.links.aysinvest}
                title='Invest Your Values | As You Sow'
                xstrong
              >Invest Your Values</Link> report card grades mutual funds on
              environmental and social issues, including climate change,
              gender equality, and weapon investments. Click through to get
              more details on each issue.
            </div>
            <div styleName='reportcard-info'>
              <strong>
                {fund.fund_legal_name}&nbsp;
              </strong>
              {
                shareClass.ticker ?
                  (
                    <em>
                      {shareClass.ticker}
                    </em>
                  ) :
                  null
              }
            </div>
            <div styleName='reportcard-control-wrap'>
              {
                hasUssifBadge ?
                  (
                    <img
                      styleName='ussif'
                      src={ussifLogo}
                      alt='Member of USSIF'
                      data-multiline
                      data-effect='solid'
                      data-tip={
                        '<div style=\'max-width:250px;\'>Member of The Forum ' +
                          'for Sustainable and Responsible Investment.</div>'
                      }
                      data-html
                      data-place='bottom'
                      data-for='reportcard-ussif-tooltip'
                    />
                  ) :
                  null
              }
              {
                hasSRIBadge ?
                  (
                    <img
                      styleName='sri'
                      src={sriIcon}
                      alt='socially responsible'
                      data-multiline
                      data-effect='solid'
                      data-tip={
                        '<div style=\'max-width:250px;\'>Reports a ' +
                          'Sustainability Mandate to Morningstar. ' +
                          'Sustainable funds consider issues like the ' +
                          'environment and human rights.</div>'
                      }
                      data-html
                      data-place='bottom'
                      data-for='reportcard-sri-tooltip'
                    />
                  ) :
                  null
              }
              <ReactTooltip id='reportcard-sri-tooltip'/>
              <ReactTooltip id='reportcard-ussif-tooltip'/>
            </div>
          </div>
          <div styleName='reportcard-results'>
            <h3 styleName='reportcard-section-header'>
              Environment
            </h3>
            {enviroFinData.map((e, idx) => {
              return (
                <div key={`iyv-result-${idx}`}>
                  <Link
                    to={e.link.url}
                    title={e.link.title}
                  >
                    <div styleName={`reportcard-result-wrap ${e.label}-row`}>
                      <ReportCardRow data={e}/>
                    </div>
                  </Link>
                </div>
              )
            })}
            <h3 styleName='reportcard-section-header'>
              Social
            </h3>
            {socialFinData.map((e, idx) => {
              return <div key={`iyv-result-${idx}`}>
                <Link
                  to={e.link.url}
                  title={e.link.title}
                >
                  <div styleName={`reportcard-result-wrap ${e.label}-row`}>
                    <ReportCardRow data={e}/>
                  </div>
                </Link>
              </div>
            })}
          </div>
          <div styleName='autocomplete-headline'>
            Search more funds
          </div>
          <AutocompleteSearch />
        </div>
      </div>
    )
  }
}